import classNames from "classnames";
import styles from "./content-page-body.less";

type ContentPageBodyProps = {
    children: React.ReactNode | Array<React.ReactNode>;
    isMaxWidth: boolean;
    className?: string;
    isPageHeight?: boolean;
};

export const ContentPageBody = (props: ContentPageBodyProps) => {
    const { children, isMaxWidth, className, isPageHeight } = props;
    return (
        <div className={classNames(
            styles.contentPageBody,
            isMaxWidth ? "" : styles.widthLimited,
            isPageHeight ? styles.pageHeightBody : "",
            className ? className : ""
        )}>
            {children}
        </div>
    );
};